// @ts-ignore
import toNumber from 'lodash/toNumber';
// @ts-ignore
import get from 'lodash/get';
export const formatEndlessRange = (value, options) => {
    const endless = options.max === Infinity;
    const { min, max } = options;
    let [start, end] = value;
    start = toNumber(start);
    end = endless ? (end !== 0 && end ? toNumber(end) : Infinity) : toNumber(end);
    if (isNaN(end) || end < start || end > max) {
        end = max;
    }
    if (isNaN(start) || start > end || start < min) {
        start = min;
    }
    return [start, end === Infinity ? '' : end];
};
export const getEndlessRange = (rangeLike, options) => {
    const endless = options.max === Infinity;
    return [
        get(rangeLike, 'start', options.min),
        get(rangeLike, 'end', endless ? '' : options.max),
    ];
};
export const fromEndlessRange = (rng = [], options) => {
    const endless = options.max === Infinity;
    const start = get(rng, '[0]', options.min);
    let end = get(rng, '[1]', endless ? undefined : options.max);
    end = end === '' ? undefined : end;
    return {
        start,
        end,
    };
};
export const removeHtml = (str) => {
    return str.replace(/<[^>]+>/g, '');
};
